import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import Vuex from "vuex";
import axios from "axios";
import store from "./store";

const base = axios.create({
  baseURL: 'http://18.228.171.115:8090', responseType: 'json',
  header: {
    "Content-Type": "application/json",     "Access-Control-Allow-Headers": "Authorization",
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  }
});

Vue.prototype.$http = base;
Vuex.Store.prototype.$http = base;
Vue.use(vuetify);
Vue.config.productionTip = false;

Vue.use(require("vue-pusher"), {
  api_key: "7f82733934876b52c151",
  secret: "f1092bc50dd2cf5c50e8",
  app_id:"953684",
  options: {
    cluster: "us2",
    encrypted: true,
  }
});

router.beforeEach((to, from, next) => {
  let userRole = null;
  if (store.getters.user && store.getters.user.roles[0]) {
    userRole = store.getters.user.roles[0].name;
    /*console.log('Teste de rules:', !store.getters.acceptedTerm && to.name !== 'TermsOfUse')
    console.log(store.getters.user.roles[0].name)
    console.log(store.getters.userRule)*/

  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if(!store.getters.user) {
      next({path: "/"});
    } 
    else if (!store.getters.acceptedTerm && to.name !== 'TermsOfUse') {
      next({replace:true,path:'/termsofuse'})
    } 
    else if (to.name === 'TermsOfUse' && store.getters.acceptedTerm) {
      next(false)
    } 
    else if(userRole !== null) {
      next();
    } 
    else 
    { 
      next({path:'/erroraccess'}) 
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!store.getters.user || to.name === 'UnauthorizedAccess') {
      next();
    } 
    else if( to.name !== 'UnauthorizedAccess'){
      if(store.getters.userRule.includes("admin")){
        next({ path: "/userslist" });
      }
      else if(store.getters.userRule.includes("tarm")){
        next({ path: "/tarmcalls" });
      }
      else if(store.getters.userRule.includes("regulatory-physician")){
        next({ path: "/doctorcalls" });
      }
      else if(store.getters.userRule.includes("fleet-manager")){
        next({ path: "/FleetManager" });
      }
      else { next({path:'/erroraccess'}) }
    }
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
